var _path, _mask, _rect, _mask2, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgResizeUp = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M19 10V5h-5"
})), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "resize-up_svg__a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 22,
  x: 1,
  y: 1,
  rx: 1
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 22,
  x: 1,
  y: 1,
  stroke: "#fff",
  strokeLinejoin: "round",
  strokeWidth: 3,
  mask: "url(#resize-up_svg__a)",
  rx: 1
})), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
  id: "resize-up_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("rect", {
  width: 11,
  height: 11,
  x: 1,
  y: 12,
  rx: 1
}))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 11,
  height: 11,
  x: 1,
  y: 12,
  stroke: "#fff",
  strokeLinejoin: "round",
  strokeWidth: 3,
  mask: "url(#resize-up_svg__b)",
  rx: 1
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 1.51,
  d: "m19 5-5 5"
})));
SvgResizeUp.viewBox = null;
const ForwardRef = /*#__PURE__*/forwardRef(SvgResizeUp);
export default ForwardRef;